// @ts-nocheck
import {
    EVENT_LOADED,EVENT_LOADING,EVENT_MODE_RESET, 
} from '../core/events.js';
import { EventDispatcher } from 'three';
import { Floorplan } from './floorplan.js';

/**
 * A Model is an abstract concept the has the data structuring a floorplan. It connects a {@link Floorplan} and a {@link Scene}
 */

export class Model extends EventDispatcher {
    constructor() {
        super();
        this.__floorplan = new Floorplan();
    }

    switchWireframe(flag) {
        this.scene.switchWireframe(flag);
    }
    __wallSelected(evt) {
        this.__selectedEdge = evt.item;
        this.__selectedEdgeNormal = evt.normal;
        this.__selectedEdgePoint = evt.point;
        this.__wallThickness = Dimensioning.cmToMeasureRaw(evt.item.thickness);
    }

    loadSerialized(json) {
        this.dispatchEvent({ type: EVENT_LOADING, item: this });
        var data = JSON.parse(json);
        this.newDesign(data.floorplanner);
        this.dispatchEvent({ type: EVENT_LOADED, item: this});
    }

    exportSerialized() {
        let floorplanJSON = this.floorplan.saveFloorplan();
        var room = { floorplanner: floorplanJSON};
        return JSON.stringify(room);
    }

    newDesign(floorplan) {
        this.floorplan.loadFloorplan(floorplan);
    }

    reset() {
        this.floorplan.reset();
        this.dispatchEvent({ type: EVENT_MODE_RESET });
    }

    get floorplan() {
        return this.__floorplan;
    }

}